import { createSelector } from "reselect";
import { IRootState } from "../rootReducer";

const userSelector = (state: IRootState) => state.user;

export const selectUserId = createSelector([userSelector], (user) => user.id);

export const selectUserEmail = createSelector([userSelector], (user) => user.email);

export const selectUserRoles = createSelector([userSelector], (user) => user.roles);

export const selectUserEmployementCode = createSelector([userSelector], (user) => user.employee_code);
